/**
 * @desc 已核对信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.CustomsClearanceYHDRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsClearance/yhdCustomsClearance`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
